import React from 'react';

import { Stepper } from '@/shared/components/stepper';
import { cn } from '@/shared/utils/cn';

export type FlowLayoutProps = {
  children: React.ReactNode;
  stepper?: {
    steps: string[];
    currentStep: number;
  };
};

export const FlowLayout = ({ children, stepper }: FlowLayoutProps) => {
  return (
    <div className="grid min-h-svh w-full grid-rows-[150px,1fr] justify-items-center p-4 pt-16 md:p-10 md:pt-20 lg:grid-cols-[3fr,7fr,3fr] lg:grid-rows-1 lg:items-center lg:justify-items-stretch lg:gap-x-4 lg:gap-y-8 lg:pt-10">
      <FlowLayoutStepper>
        {stepper && (
          <Stepper currentStep={stepper.currentStep}>
            {stepper.steps.map((step) => (
              <Stepper.Step key={step}>{step}</Stepper.Step>
            ))}
          </Stepper>
        )}
      </FlowLayoutStepper>
      {children}
    </div>
  );
};

const FlowLayoutStepper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mb-6 flex w-full flex-row items-end truncate">
      <div className="lg:w-[20%]" />
      {children}
    </div>
  );
};

export const FlowLayoutBody = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn('mx-auto w-full max-w-2xl', className)}>{children}</div>
  );
};
